import {Checkbox, IconButton, openDeleteDialog, Tooltip} from 'platform/components';
import {Box, Heading, HStack, Text, VStack} from 'platform/foundation';

import {MappedBasketItem, TITLE_TOOLTIP_OPEN_DELAY} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {PlainMaterialBasketItem} from '../types/PlainMaterialBasketItem';

interface AfterSalesPlainMaterialBasketItemTitleWithActionsProps<T extends PlainMaterialBasketItem>
  extends RequiredTestIdProps {
  item: MappedBasketItem<T>;
  manufacturerName: string;
  onSelect: (itemId: string, isSelected: boolean) => void;
  onDelete: (itemsIds: string[]) => void;
}

export function AfterSalesPlainMaterialBasketItemTitleWithActions<
  T extends PlainMaterialBasketItem,
>(props: AfterSalesPlainMaterialBasketItemTitleWithActionsProps<T>) {
  const handleDeleteItem = () => {
    openDeleteDialog({
      name: props.item.catalogNumber,
      onConfirm: () => props.onDelete([props.item.id]),
      'data-testid': suffixTestId('delete', props),
    });
  };

  return (
    <VStack spacing={1}>
      <HStack align="center" spacing={2}>
        <Checkbox
          value={props.item.isSelected}
          onChange={(isSelected) => props.onSelect?.(props.item.id, isSelected)}
          data-testid={suffixTestId('isSelected', props)}
        />
        <Box flexGrow={1} minWidth={0}>
          <Tooltip
            label={props.item.catalogNumber}
            placement="top"
            openDelay={TITLE_TOOLTIP_OPEN_DELAY}
            hasAutoWidth
          >
            <Heading size={4} isSingleLine data-testid={suffixTestId('catalogNumber', props)}>
              {props.item.catalogNumber}
            </Heading>
          </Tooltip>
        </Box>
        <HStack justify="flex-end" shrink={0} spacing={1}>
          <IconButton
            icon="navigation/close"
            size="small"
            priority="primary"
            severity="danger"
            onClick={handleDeleteItem}
            data-testid={suffixTestId('delete', props)}
          />
        </HStack>
      </HStack>
      <HStack spacing={1} align="center">
        <Text size="xSmall" color="tertiary" data-testid={suffixTestId('manufacturerName', props)}>
          {props.manufacturerName}
        </Text>
      </HStack>
    </VStack>
  );
}
